import {
  Glass,
  BodyText,
  DisplayText,
  ScreenLabel,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";
import { DataNeedIcon } from "./journey-shared";

export function JourneySkillDetailScreen() {
  const accent = "var(--color-kin-rose)";

  const analyzes = [
    "VO2 max estimation from workout data",
    "Resting heart rate trends",
    "Workout intensity distribution",
    "Cardiovascular recovery patterns",
  ];

  const dataNeeds = [
    { type: "wearable", label: "Wearable (HR data)", required: true },
    { type: "workout", label: "Workout history", required: true },
    { type: "sleep", label: "Sleep data", required: false },
    { type: "lab", label: "Blood panel (lipids)", required: false },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative",
      }}
    >
      {/* Hero band */}
      <div
        style={{
          padding: "20px 16px 16px",
          background: `linear-gradient(135deg, ${alpha(accent, "14")}, ${alpha(accent, "06")})`,
          borderBottom: borderAlpha(accent, "20"),
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: accent,
            }}
          />
          <BodyText
            size={8}
            color={accent}
            weight={700}
            style={{ letterSpacing: "0.1em", textTransform: "uppercase" }}
          >
            Fitness
          </BodyText>
        </div>
        <DisplayText size={22} color="var(--color-kin-black)">
          Cardio Fitness
        </DisplayText>
        <BodyText size={9} color="var(--color-kin-muted)" weight={500} style={{ marginTop: 3 }}>
          by Dr. Sara Chen
        </BodyText>
      </div>

      <div
        style={{
          padding: "12px 16px 0",
          display: "flex",
          flexDirection: "column",
          gap: 12,
          flex: 1,
        }}
      >
        {/* Description */}
        <BodyText
          size={9.5}
          color="var(--color-kin-muted)"
          weight={400}
          style={{ lineHeight: 1.55 }}
        >
          Tracks VO2 trends, resting heart rate, and workout intensity to build a cardiovascular
          fitness baseline. Identifies patterns in your training load and recovery to help optimize
          endurance.
        </BodyText>

        {/* What it analyzes */}
        <div>
          <ScreenLabel style={{ marginBottom: 6, display: "block" }}>What it analyzes</ScreenLabel>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {analyzes.map((item) => (
              <div key={item} style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <div
                  style={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: accent,
                    flexShrink: 0,
                  }}
                />
                <BodyText size={9} color="var(--color-kin-black)" weight={500}>
                  {item}
                </BodyText>
              </div>
            ))}
          </div>
        </div>

        {/* Data requirements */}
        <div>
          <ScreenLabel style={{ marginBottom: 6, display: "block" }}>Data requirements</ScreenLabel>
          <Glass style={{ padding: "0 11px" }}>
            {dataNeeds.map((need, i) => (
              <div
                key={need.label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "8px 0",
                  borderBottom: i < dataNeeds.length - 1 ? "1px solid rgba(0,0,0,0.05)" : "none",
                }}
              >
                <DataNeedIcon type={need.type} accent={accent} />
                <BodyText size={9.5} weight={600} style={{ flex: 1 }}>
                  {need.label}
                </BodyText>
                <BodyText
                  size={7.5}
                  color={need.required ? accent : "var(--color-kin-muted)"}
                  weight={600}
                >
                  {need.required ? "Required" : "Optional"}
                </BodyText>
              </div>
            ))}
          </Glass>
        </div>

        {/* Creator card */}
        <Glass
          style={{
            padding: "10px 12px",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${alpha(accent, "20")}, ${alpha(accent, "10")})`,
              border: borderAlpha(accent, "30"),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <BodyText size={12} weight={700} color={accent}>
              S
            </BodyText>
          </div>
          <div style={{ flex: 1 }}>
            <BodyText size={10} weight={700}>
              Dr. Sara Chen
            </BodyText>
            <BodyText size={8} color="var(--color-kin-muted)" weight={400}>
              Sports cardiologist · 4 skills published
            </BodyText>
          </div>
        </Glass>
      </div>

      {/* Install CTA */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "8px 16px 12px",
          background: "linear-gradient(to top, rgba(248,245,238,1) 60%, rgba(248,245,238,0))",
          zIndex: 5,
        }}
      >
        <div
          style={{
            background: "var(--color-kin-lavender)",
            borderRadius: 14,
            padding: "12px 0",
            textAlign: "center",
            boxShadow: "0 4px 16px -4px rgba(165,144,255,0.4)",
          }}
        >
          <BodyText size={11} color="#fff" weight={700}>
            Install
          </BodyText>
        </div>
      </div>
    </div>
  );
}
